import {
   ADDITIONAL_SEAT_COST,
   BASE_SEAT_COST,
} from '@forwardflow/constants/onboarding.constants'
import { TFubUser } from '@forwardflow/types/onboarding'

export const MAX_SEATS = 50

/** $97 for the first seat, $50 for each one after it. */
export const seatCostFor = (seats: number) =>
   BASE_SEAT_COST + Math.max(0, seats - 1) * ADDITIONAL_SEAT_COST

/** The plan is never asked for: one seat is Solo, more is Team. */
export const planNameFor = (seats: number) => (seats > 1 ? 'Team' : 'Solo')

/** "Just you" or "You + 2". */
export const seatWords = (seats: number) =>
   seats > 1 ? `You + ${seats - 1}` : 'Just you'

/**
 * Who the signed-in person is in Follow Up Boss: the user with the same
 * email, else the account owner, else the first user. `null` when the list
 * is empty.
 */
export const pickOwner = (
   users: TFubUser[],
   email: string | null | undefined
): TFubUser | null => {
   if (!users.length) return null
   const wanted = (email || '').trim().toLowerCase()
   return (
      (wanted && users.find((u) => (u.email || '').toLowerCase() === wanted)) ||
      users.find((u) => u.isOwner) ||
      users[0]
   )
}

export const fullName = (u: Partial<TFubUser> | null | undefined) =>
   `${u?.firstName || ''} ${u?.lastName || ''}`.trim() ||
   u?.name ||
   u?.email ||
   ''

/** The owner on the record, if one was confirmed. */
export const ownerOf = (invited: TFubUser[] | undefined | null) =>
   (invited || []).find((u) => u.isOwner) || null

/** The teammates on the record (everyone but the owner). */
export const membersOf = (invited: TFubUser[] | undefined | null) =>
   (invited || []).filter((u) => !u.isOwner)
